<script setup>
import { ElConfigProvider } from "element-plus";
</script>

<template>
  <el-config-provider size="large">
    <router-view></router-view>
  </el-config-provider>
</template>
